import { AqiType } from '../enums/aqi.type';

export const DEFAULT_AQI_TYPE = AqiType.instant;
